// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__3-Awc","sideconstruct":"sidebar_sideconstruct__OdfUr"};